import React, { useContext } from "react";
import { t } from "ttag";

import { ReactivatedContext } from "../../../context";
import { buildLocalImage } from "../../../utils/buildLocalImage";
import { ButtonPrimary, Clickable } from "../../Clickables";
import { SuiteSnapshotBlock } from "../../SuiteBuilderPromoBlock/SuiteSnapshotBlock";
import { Action, discountRules } from "../engine";

import styles from "./InitialLanding.module.scss";

const SNAPSHOT_IMG = {
    width: 500,
    height: 500,
    mimetype: "image/webp",
    alt: "",
};

type InitialLandingProps = {
    dispatch: React.Dispatch<Action>;
    onShowOfferDetails: () => void;
};

export const InitialLanding = ({
    dispatch,
    onShowOfferDetails,
}: InitialLandingProps) => {
    const { STATIC_URL } = useContext(ReactivatedContext);
    const base = `${STATIC_URL}suite-builder/initial-landing/`;

    const ratePct = Math.round(discountRules[0].discountRate * 100);
    const startWalk = () => dispatch({ type: "START_INITIAL_WALK" });

    return (
        <section className={styles.root} data-testid="initial-landing">
            <h1 className={styles.heading}>{t`Build Your Dream Suite`}</h1>
            <p className={styles.body}>
                {t`
                    Bring the sophistication and precision of SKS to your home.
                    Our seamless step-by-step tool will ensure you have all the
                    information you need when you visit your local dealer.
                `}
            </p>
            <div className={styles.ctaContainer}>
                <ButtonPrimary onClick={startWalk}>
                    {t`Get Started`}
                </ButtonPrimary>
            </div>
            <SuiteSnapshotBlock
                className={styles.snapshot}
                value={{
                    images: [
                        buildLocalImage(`${base}1-range.webp`, SNAPSHOT_IMG),
                        buildLocalImage(`${base}2-fridge.webp`, SNAPSHOT_IMG),
                        buildLocalImage(
                            `${base}3-wall-oven.webp`,
                            SNAPSHOT_IMG,
                        ),
                        buildLocalImage(
                            `${base}4-dishwasher.webp`,
                            SNAPSHOT_IMG,
                        ),
                    ],
                    caption: t`A collection of SKS Appliances. Start building your dream suite today!`,
                }}
                cta={startWalk}
            />
            <p className={styles.body}>
                {t`When you choose two or more eligible SKS appliances, you’ll earn ${ratePct}% instant savings.`}
            </p>
            <div className={styles.ctaContainer}>
                <Clickable
                    className={styles.dialogTrigger}
                    onPress={onShowOfferDetails}
                >
                    {t`See offer details`}
                </Clickable>
            </div>
        </section>
    );
};
